<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>event</mat-icon>
      Special Events
    </h2>
    <button mat-flat-button color="primary" type="button" (click)="openCreateSpecialEvent()">Create Event</button>
  </div>

  <mat-form-field class="search-field" appearance="outline">
    <mat-label>Search special events...</mat-label>
    <input matInput [(ngModel)]="specialEventsSearchTerm" (ngModelChange)="onSpecialEventsSearchTermChange()" placeholder="Search across name, sponsor, description, country, city, org">
    <button mat-icon-button matSuffix *ngIf="specialEventsSearchTerm" (click)="specialEventsSearchTerm = ''; onSpecialEventsSearchTermChange()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <table class="admin-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Event Name</th>
        <th>Sponsor</th>
        <th>Location</th>
        <th>Scheduled</th>
        <th>TD Org</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of specialEvents">
        <td>{{ item.event_id }}</td>
        <td>{{ item.event_name }}</td>
        <td>{{ item.sponsor_email }}</td>
        <td>{{ item.city }}<span *ngIf="item.city && item.country">, </span>{{ item.country }}</td>
        <td>{{ item.scheduled_start_dt }}<span *ngIf="item.scheduled_end_dt"> → {{ item.scheduled_end_dt }}</span></td>
        <td>{{ item.sponsoring_td_org }}</td>
        <td>
          <button mat-icon-button color="primary" type="button" matTooltip="Edit" aria-label="Edit special event" (click)="openEditSpecialEvent(item)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" type="button" matTooltip="Delete" aria-label="Delete special event" [disabled]="isActionBusy(specialEventDeleteActionKey(item.event_id))" (click)="deleteSpecialEvent(item)" class="delete-btn">
            <mat-spinner *ngIf="isActionBusy(specialEventDeleteActionKey(item.event_id))" diameter="16" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(specialEventDeleteActionKey(item.event_id))">delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty-state" *ngIf="specialEvents.length === 0">
    <mat-icon>search_off</mat-icon>
    <p>No special events found.</p>
  </div>

  <div class="modal-backdrop" *ngIf="isSpecialEventEditorVisible">
    <div class="modal-card mat-elevation-z8 editor-modal-card editor-modal-card--wide">
      <div class="modal-header">
        <div>
          <h3 class="editor-modal-title">
            <mat-icon>event</mat-icon>
            {{ editingSpecialEventId ? 'Edit Special Event' : 'Create Special Event' }}
            <span class="entity-id" *ngIf="editingSpecialEventId">ID: {{ editingSpecialEventId }}</span>
          </h3>
          <p class="editor-modal-subtitle">Manage the event record and its attendee roster from one dialog.</p>
        </div>
        <button mat-icon-button type="button" (click)="cancelSpecialEventEdit()" aria-label="Close special event editor">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-body editor-modal-body">
        <div class="demo-editor-section">
          <div class="form-row material-grid">
            <mat-form-field appearance="outline">
              <mat-label>Event name</mat-label>
              <input matInput [(ngModel)]="specialEventForm.event_name" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Sponsor email</mat-label>
              <input matInput [(ngModel)]="specialEventForm.sponsor_email" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Sponsoring TD org</mat-label>
              <input matInput [(ngModel)]="specialEventForm.sponsoring_td_org" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Country</mat-label>
              <input matInput [(ngModel)]="specialEventForm.country" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="specialEventForm.city" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Description</mat-label>
              <textarea matInput rows="2" [(ngModel)]="specialEventForm.description"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Scheduled start date</mat-label>
              <input matInput [matDatepicker]="schedStartPicker" [ngModel]="getEventDate('scheduled_start_dt')" (dateChange)="setEventDate('scheduled_start_dt', $event.value)" readonly />
              <mat-datepicker-toggle matSuffix [for]="schedStartPicker"></mat-datepicker-toggle>
              <mat-datepicker #schedStartPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Scheduled end date</mat-label>
              <input matInput [matDatepicker]="schedEndPicker" [ngModel]="getEventDate('scheduled_end_dt')" (dateChange)="setEventDate('scheduled_end_dt', $event.value)" readonly />
              <mat-datepicker-toggle matSuffix [for]="schedEndPicker"></mat-datepicker-toggle>
              <mat-datepicker #schedEndPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Actual start</mat-label>
              <input matInput [matDatepicker]="startTsPicker" [ngModel]="getEventDate('start_ts')" (dateChange)="setEventDate('start_ts', $event.value)" readonly />
              <mat-datepicker-toggle matSuffix [for]="startTsPicker"></mat-datepicker-toggle>
              <mat-datepicker #startTsPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Actual end</mat-label>
              <input matInput [matDatepicker]="endTsPicker" [ngModel]="getEventDate('end_ts')" (dateChange)="setEventDate('end_ts', $event.value)" readonly />
              <mat-datepicker-toggle matSuffix [for]="endTsPicker"></mat-datepicker-toggle>
              <mat-datepicker #endTsPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="demo-update-row">
            <button mat-flat-button color="primary" type="button" (click)="saveSpecialEvent()" [disabled]="isActionBusy(specialEventSaveActionKey()) || (editingSpecialEventId && !isSpecialEventFormDirty)">
              <mat-spinner *ngIf="isActionBusy(specialEventSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
              <span *ngIf="!isActionBusy(specialEventSaveActionKey())">{{ editingSpecialEventId ? 'Update' : 'Create' }}</span>
            </button>
          </div>

          <div class="embedded-section" *ngIf="editingSpecialEventId">
            <div class="section-header">
              <h2>Attendees</h2>
              <span class="section-header-actions">
                <input #attendeeFileInput type="file" hidden accept=".csv" (change)="onAttendeeFileSelected($event)" />
                <button mat-stroked-button color="primary" type="button" [disabled]="attendeeImportBusy"
                  matTooltip="Import attendees from a CSV file" (click)="attendeeFileInput.click()">
                  <mat-spinner *ngIf="attendeeImportBusy" diameter="16" class="btn-spinner"></mat-spinner>
                  <mat-icon *ngIf="!attendeeImportBusy">upload_file</mat-icon>
                  Import CSV
                </button>
                <button mat-icon-button color="primary" type="button" aria-label="Add Attendee" (click)="openCreateAttendee()">
                  <mat-icon>person_add</mat-icon>
                </button>
              </span>
            </div>

            <p class="import-hint">
              Bulk import accepts a CSV with columns: <code>email</code>, <code>name</code>, <code>company</code>, <code>type</code> (A/S/O),
              <code>start_ts</code>, <code>end_ts</code>. Existing attendees (matched by email) are updated.
            </p>

            <mat-form-field class="search-field" appearance="outline">
              <mat-label>Search attendees...</mat-label>
              <input matInput [(ngModel)]="attendeeSearchTerm" (ngModelChange)="onAttendeeSearchTermChange()" placeholder="Search by name, email, company, type">
              <button mat-icon-button matSuffix *ngIf="attendeeSearchTerm" (click)="attendeeSearchTerm = ''; onAttendeeSearchTermChange()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <table class="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="creatingAttendee || editingAttendeeEmail">
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Name</mat-label>
                      <input matInput [(ngModel)]="attendeeForm.event_attendee_name"
                        (ngModelChange)="onAttendeeNameChange($event)"
                        [matAutocomplete]="attendeeNameAuto" />
                      <mat-autocomplete #attendeeNameAuto="matAutocomplete"
                        [displayWith]="displayAttendeeSuggestion"
                        (optionSelected)="selectAttendeeSuggestion($event.option.value)">
                        <mat-option *ngFor="let user of attendeeUserSuggestions" [value]="user">
                          {{ user.name }} <span class="entity-id">{{ user.email }}</span>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Email</mat-label>
                      <input matInput [(ngModel)]="attendeeForm.email" [disabled]="!!editingAttendeeEmail" />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Company</mat-label>
                      <input matInput [(ngModel)]="attendeeForm.company" />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Type</mat-label>
                      <mat-select [(ngModel)]="attendeeForm.attendee_type">
                        <mat-option value="A">Attendee</mat-option>
                        <mat-option value="S">Sponsor</mat-option>
                        <mat-option value="O">Observer</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <button mat-icon-button color="primary" type="button" matTooltip="Save" aria-label="Save attendee" [disabled]="isActionBusy(attendeeSaveActionKey())" (click)="saveAttendee()">
                      <mat-spinner *ngIf="isActionBusy(attendeeSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" matTooltip="Cancel" aria-label="Cancel attendee edit" (click)="cancelAttendeeEdit()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
                <tr *ngFor="let att of specialEventAttendees">
                  <td>{{ att.event_attendee_name }}</td>
                  <td>{{ att.email }}</td>
                  <td>{{ att.company }}</td>
                  <td>{{ attendeeTypeLabel(att.attendee_type) }}</td>
                  <td>
                    <button mat-icon-button color="primary" type="button" matTooltip="Edit" aria-label="Edit attendee" (click)="openEditAttendee(att)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" type="button" matTooltip="Delete" aria-label="Delete attendee" [disabled]="!att.email || isActionBusy(attendeeDeleteActionKey(att.email))" (click)="deleteAttendee(att)" class="delete-btn">
                      <mat-spinner *ngIf="att.email && isActionBusy(attendeeDeleteActionKey(att.email))" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon *ngIf="!att.email || !isActionBusy(attendeeDeleteActionKey(att.email))">delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="empty-state" *ngIf="specialEventAttendees.length === 0 && !creatingAttendee">
              <mat-icon>group_off</mat-icon>
              <p>No attendees recorded for this event.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
